var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.387 2.927a1.76 1.76 0 0 0-1.76 1.76v4.694a5.564 5.564 0 1 0 11.129 0V4.687a1.76 1.76 0 0 0-1.76-1.76H7.386Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.191 15.613v.89",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.862 17.17H8.52a1.113 1.113 0 1 0 0 2.227h5.342a1.113 1.113 0 1 0 0-2.226Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.404 4.93c-1.229 0-2.225.996-2.225 2.225v.293c0 .668.265 1.308.737 1.78l1.934 1.934M16.978 4.93c1.23 0 2.226.996 2.226 2.225v.293c0 .668-.265 1.308-.738 1.78l-1.933 1.934",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrophy;